import React, { useEffect, useState } from 'react';
import '../footer/footer.css';
import '../../App.css';
import fbImg from '../../images/s-icon1.svg';
import twImg from '../../images/s-icon2.svg';
import indImg from '../../images/s-icon3.svg';
// import indImg from '../../images/s-icon4.svg';
import footerLogo from '../../images/carter-logo.svg';
import { END_URL } from "../../config.js";
import axios from 'axios';

function Footer() {

    const [Footer, setFooter] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
        try {

            const response = await axios.get(`${END_URL}footer`);
          
            setFooter(response.data.data);
            
        } catch (error) {
            console.error('Error fetching news:', error);
        }
        };
        fetchData();
    }, []);

    const footerList = [
        { item: "About Carter Capner Law", link: "/aboutPage" },
        
        { item: "Case Details", link: "/#case_update" },
        { item: "Eligibility", link: "/#eligibility" },

        { item: "News & Updates", link: "/#newswrap" },

    ];

    const footerList1 = [
        { item: "Privacy Policy", link: "/privacy" },  // Added link
        { item: "Terms of Use", link: "/terms" },
        { item: "Contact", link: "/contact" }    // Added link
    ];

    return (
        <footer>
            <div className="container">
                <div className="footer-row1">
                    <div className="footer-logo">
                        <img src={footerLogo} alt="footer-logo" />
                        <p>Since 1944, Carter Capner Law has been standing up for everyday Australians. We are leading this class action to ensure you are compensated for deceptive pricing tactics.</p>
                    </div>
                    <div className="footer-list">
                        <h4>Key Sections</h4>
                        <ul>
                            {footerList?.map((list, index) => (
                                <li key={index}>

                                    {list.link.startsWith("/#") ? (
                                    <a
                                        href=""
                                        style={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                        e.preventDefault();
                                        const id = list.link.replace("/#", "");
                                        const el = document.getElementById(id);

                                        if (el) {
                                            const yOffset = -100; // 100px offset
                                            const y =
                                            el.getBoundingClientRect().top +
                                            window.pageYOffset +
                                            yOffset;

                                            window.scrollTo({ top: y, behavior: "smooth" });
                                        }
                                        }}
                                    >
                                        {list.item}
                                    </a>

                                    ) : (
                                    <a href={list.link}>{list.item}</a>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="footer-list">
                        <h4>Legal Information</h4>
                        <ul>
                            {footerList1?.map((list, index) => (
                                <li key={index}>
                                    <a href={list.link}>{list.item}</a>  {/* Updated href */}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="footer-list">
                        <h4>Get in touch</h4>

                        <div className='footer-address' dangerouslySetInnerHTML={{__html:Footer?.footer_address}}/>
                        
                        <div className="social-list">
                            <a href="#" className='social-icon'>
                                <img src={fbImg} alt="facebook" />
                            </a>
                            <a href="#" className='social-icon'>
                                <img src={twImg} alt="twitter" />
                            </a>
                            <a href="#" className='social-icon'>
                                <img src={indImg} alt="indeed" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="footer-row2">
                    <ul>
                        <li>© {new Date().getFullYear()} Carter Capner Law. All Rights Reserved.</li>
                         <li>    
                            This portal is for registered participants only. The information contained herein is confidential.{' '}
                            <a href="/privacy" className="link">Privacy Policy</a>.  
                        </li>    
                    </ul>
                    <small>The information on this website is for general purposes only and does not constitute legal advice.</small>
                    
                </div>
            </div>
        </footer>
    )
}

export default Footer
